import { render, staticRenderFns } from "./CoursesSection.vue?vue&type=template&id=a8de6f3a&scoped=true&"
import script from "./CoursesSection.vue?vue&type=script&lang=js&"
export * from "./CoursesSection.vue?vue&type=script&lang=js&"
import style0 from "./CoursesSection.vue?vue&type=style&index=0&id=a8de6f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8de6f3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
